import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CentralizedLoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  
  private activeRequests = new Map<string, boolean>();
  private requestCounter = 0;

  constructor() {}

  // Generate unique request ID
  private generateRequestId(): string {
    return `request_${++this.requestCounter}_${Date.now()}`;
  }

  // Start loading for a specific request
  startLoading(requestId?: string): string {
    const id = requestId || this.generateRequestId();
    this.activeRequests.set(id, true);
    this.updateLoadingState();
    return id;
  }

  // Stop loading for a specific request
  stopLoading(requestId: string): void {
    if (this.activeRequests.has(requestId)) {
      this.activeRequests.delete(requestId);
      this.updateLoadingState();
    }
  }

  // Force stop all loading
  stopAllLoading(): void {
    this.activeRequests.clear();
    this.updateLoadingState();
  }

  // Check if any requests are active
  isLoading(): boolean {
    return this.activeRequests.size > 0;
  }

  // Get count of active requests
  getActiveRequestsCount(): number {
    return this.activeRequests.size;
  }

  // Update the loading state based on active requests
  private updateLoadingState(): void {
    const isLoading = this.activeRequests.size > 0;
    this.loadingSubject.next(isLoading);
  }

  // Get all active request IDs (for debugging)
  getActiveRequestIds(): string[] {
    return Array.from(this.activeRequests.keys());
  }
}
